import React from "react";

const LayoutContext = React.createContext(true); 

export default LayoutContext;
